// src/config/portfolio.config.js
export const portfolioConfig = {
  name: "Pawan Kumar",
  username: "codepur_ka_superhero",
  avatar:
    "https://media.licdn.com/dms/image/D5603AQHaXeX7zixwIg/profile-displayphoto-shrink_200_200/0/1707500257800?e=2147483647&v=beta&t=nixbJF-vQioy8jhDWL0D95THcyL0gF2hAuLAa00_4Mk",
  bio: "Mobile App Developer | GDE | React Enthusiast | Coffee Lover",
  posts: [
    {
      id: 1,
      image:
        "https://topmate-staging.s3.amazonaws.com/mBsBcNnQ7KLTMWyeD5uifB.png",
      caption:
        "Just launched SOLID by Spidey - Learn SOLID Principles Pay as you wish #solid #code",
      likes: "542",
      isLiked: true,
      comments: [
        { user: "dev_enthusiast", text: "Great work! Love the book." },
        { user: "react_fan", text: "The content is on point!" },
      ],
    },
    {
      id: 2,
      image:
        "https://topmate-staging.s3.amazonaws.com/x9441ah5SEfiJyiuG7x76D.png",
      caption: "Flutter Zero: Become Flutter Expert in 30 Days! #flutter",
      likes: 228,

      isLiked: false,
      comments: [
        { user: "dev_enthusiast", text: "Great work! Love the book." },
        { user: "flutter_fan", text: "Flutter is the way to go ❤️" },
        {
          user: "flutter_lover 💙",
          text: "Very nice book, I love it",
        },
      ],
    },
    {
      id: 3,
      image: "https://i.ytimg.com/vi/j-LOab_PzzU/maxresdefault.jpg",
      caption:
        "Master Flutter in just 8 Hours | Full course on Codepur. #coding",
      likes: 120,
      isLiked: false,
      comments: [
        { user: "dev_enthusiast", text: "Looking forward to it!" },
        {
          user: "coding_ninja",
          text: "Can't wait to see what you've been working on!",
        },
      ],
    },
    {
      id: 4,
      image: "https://i.ytimg.com/vi/uTZ-BEDOueM/maxresdefault.jpg",
      caption:
        "I will be speaking at Google I/O 2024 on 'Building Flutter Apps in 2024'",
      likes: 87,
      isLiked: true,
      comments: [
        { user: "tech_guru", text: "Thanks for the recommendation!" },
        { user: "bookworm", text: "I'll add it to my reading list!" },
      ],
    },

    // Add more posts as needed
  ],
  stories: [
    {
      id: 1,
      image: "https://cdn.worldvectorlogo.com/logos/flutter.svg",
      title: "Flutter",
      viewed: false,
    },
    {
      id: 13,
      image: "https://cdn.worldvectorlogo.com/logos/dart.svg",
      title: "Dart",
      viewed: false,
    },
    {
      id: 2,
      image: "https://cdn.worldvectorlogo.com/logos/react-1.svg",
      title: "React",
      viewed: true,
    },

    {
      id: 3,
      image: "https://cdn.worldvectorlogo.com/logos/vue-9.svg",
      title: "Vue.js",
      viewed: false,
    },
    {
      id: 4,
      image: "https://cdn.worldvectorlogo.com/logos/angular-icon-1.svg",
      title: "Angular",
      viewed: true,
    },
    {
      id: 5,
      image: "https://cdn.worldvectorlogo.com/logos/typescript.svg",
      title: "TypeScript",
      viewed: false,
    },
    {
      id: 6,
      image: "https://cdn.worldvectorlogo.com/logos/html-1.svg",
      title: "HTML5",
      viewed: true,
    },
    {
      id: 7,
      image: "https://cdn.worldvectorlogo.com/logos/css-3.svg",
      title: "CSS3",
      viewed: false,
    },
    {
      id: 8,
      image: "https://cdn.worldvectorlogo.com/logos/sass-1.svg",
      title: "Sass",
      viewed: true,
    },
    {
      id: 9,
      image: "https://cdn.worldvectorlogo.com/logos/bootstrap-4.svg",
      title: "Bootstrap",
      viewed: false,
    },
    {
      id: 10,
      image: "https://cdn.worldvectorlogo.com/logos/nodejs-icon.svg",
      title: "Node.js",
      viewed: true,
    },
    {
      id: 11,
      image: "https://cdn.worldvectorlogo.com/logos/express-109.svg",
      title: "Express.js",
      viewed: false,
    },
    {
      id: 12,
      image: "https://cdn.worldvectorlogo.com/logos/mongodb-icon-1.svg",
      title: "MongoDB",
      viewed: true,
    },

    // Add more stories as needed
  ],
  initialConversations: [
    {
      id: 1,
      user: "Manuja",
      lastMessage: "Hey, I loved your Flutter projects!",
      avatar:
        "https://avataaars.io/?avatarStyle=Transparent&topType=LongHairMiaWallace&accessoriesType=Kurt&hairColor=Blonde&facialHairType=Blank&facialHairColor=BrownDark&clotheType=BlazerShirt&eyeType=Side&eyebrowType=SadConcerned&mouthType=Smile&skinColor=Pale",
    },
    {
      id: 2,
      user: "Aakash Tewari",
      lastMessage: "Are you available for freelance work?",
      avatar:
        "https://avataaars.io/?avatarStyle=Transparent&topType=ShortHairDreads01&accessoriesType=Wayfarers&hairColor=Blonde&facialHairType=BeardMajestic&facialHairColor=Auburn&clotheType=BlazerShirt&clotheColor=Blue02&eyeType=Surprised&eyebrowType=SadConcerned&mouthType=ScreamOpen&skinColor=Pale",
    },
    {
      id: 3,
      user: "Shraddha Kapoor",
      lastMessage: "Your youtube videos are amazing!",
      avatar:
        "https://avataaars.io/?avatarStyle=Transparent&topType=LongHairStraightStrand&accessoriesType=Blank&hairColor=Blue&facialHairType=Blank&facialHairColor=Blonde&clotheType=ShirtScoopNeck&clotheColor=PastelGreen&eyeType=Surprised&eyebrowType=AngryNatural&mouthType=Twinkle&skinColor=Light",
    },
  ],
  projects: [
    {
      title: "Project 1",
      description: "A detailed description of project 1...",
      image: "/path/to/project1.jpg",
      link: "https://project1.com",
      category: "web",
    },
    // Add more projects with categories
  ],
  skills: [
    {
      name: "React",
      icon: "https://cdn.worldvectorlogo.com/logos/react-1.svg",
      level: "Advanced",
    },
    {
      name: "JavaScript",
      icon: "https://cdn.worldvectorlogo.com/logos/javascript-1.svg",
      level: "Advanced",
    },
    {
      name: "Flutter",
      icon: "https://cdn.worldvectorlogo.com/logos/flutter-logo.svg",
      level: "Intermediate",
    },
    {
      name: "Django",
      icon: "https://cdn.worldvectorlogo.com/logos/django.svg",
      level: "Intermediate",
    },
    // Add more skills as needed
  ],
};
